import {ReactElement} from "react";
import {Body, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import {toast} from "react-toastify";
import {useDeletePayrollJurisdictionMutation} from "../../../../__generated__/generated_types";

interface JurisdictionDeleteModalProps {
    close: (deleted: boolean) => void;
    jurisdictionIds: string[];
}

export function JurisdictionDeleteModal(props: JurisdictionDeleteModalProps): ReactElement {
    const [deleteJurisdiction, {loading: deleteLoading}] = useDeletePayrollJurisdictionMutation({
        fetchPolicy: "no-cache"
    });

    function doDelete(ids: string[]): void {
        if(ids.length === 0) {
            return;
        }

        Promise.all(
            ids.map(id => deleteJurisdiction({variables: {id}}))
        ).then(() => {
            toast.success(`Deleted ${ids.length} Jurisdiction${ids.length > 1 ? "s" : ""}.`);
            props.close(true);
        });
    }

    return <Modal>
        <Header>Delete Jurisdiction{props.jurisdictionIds.length > 1 ? "s" : ""}</Header>
        <Body>
            Are you sure you want to delete {props.jurisdictionIds.length} jurisdiction{props.jurisdictionIds.length > 1 ? "s" : ""}?
            <p style={{marginTop: "0.5em", color: "var(--grey-500)", fontSize: "0.85rem"}}>
                Any associated properties will be dissociated.
            </p>
        </Body>
        <Footer>
            <FooterItem>
                <Button isBasic onClick={() => props.close(false)}>Cancel</Button>
            </FooterItem>
            <FooterItem>
                <Button isDanger disabled={deleteLoading} onClick={() => doDelete(props.jurisdictionIds)}>Delete</Button>
            </FooterItem>
        </Footer>
    </Modal>;
}
